var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconProjectlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1596_29984)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3V19H9.25204C9.08751 18.3608 9 17.6906 9 17H4V5H9.175L11.175 7H20V9.58152C20.7257 9.87526 21.3984 10.2724 22 10.7546V5H12L10 3H2Z",
    fill: "#4E629F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3639 11.276H17.6366V13.8215H16.3639V11.276ZM18.9087 16.9986C18.9087 18.053 18.054 18.9077 16.9997 18.9077C15.9453 18.9077 15.0906 18.053 15.0906 16.9986C15.0906 15.9443 15.9453 15.0895 16.9997 15.0895C18.054 15.0895 18.9087 15.9443 18.9087 16.9986ZM20.182 16.3656H22.7274V17.6383H20.182V16.3656ZM13.8179 16.3656H11.2725V17.6383H13.8179V16.3656ZM17.6366 20.1791H16.3639V22.7246H17.6366V20.1791Z",
    fill: "#4E629F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 24C20.866 24 24 20.866 24 17C24 13.134 20.866 10 17 10C13.134 10 10 13.134 10 17C10 20.866 13.134 24 17 24ZM21.9927 16H20V18H21.9927C21.5925 20.0094 20.0094 21.5925 18 21.9927V20H16V21.9927C13.9906 21.5925 12.4075 20.0094 12.0073 18H14V16H12.0073C12.4075 13.9906 13.9906 12.4075 16 12.0073V14H18V12.0073C20.0094 12.4075 21.5925 13.9906 21.9927 16Z",
    fill: "#4E629F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1596_29984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectlist);
export default __webpack_public_path__ + "static/media/icon_projectlist.c3d62a252ead2a987bca95962b7e081a.svg";
export { ForwardRef as ReactComponent };